import axios from "axios";

var getMeetingsWithAttachments = function getMeetingsWithAttachments(groupId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return axios.get("/groups/" + groupId + "/meetings-where-relation-exist?include=attachments:order(created_at|desc)&page=" + page);
};

var getMeetingAttachments = function getMeetingAttachments(groupId, meetingId) {
  return axios.get("/groups/" + groupId + "/meetings/" + meetingId + "/attachments");
};

var storeMeetingAttachments = function storeMeetingAttachments(groupId, meetingId, request) {
  return axios.post("groups/" + groupId + "/meetings/" + meetingId + "/attachments", request, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

var deleteAttachment = function deleteAttachment(groupId, attachmentId) {
  return axios.delete("groups/" + groupId + "/attachments/" + attachmentId);
};

export { getMeetingsWithAttachments, getMeetingAttachments, storeMeetingAttachments, deleteAttachment };